@if (service.isOpen()) {
  @if (isMobile()) {
    <div
      class="search-overlay search-overlay--sheet"
      role="dialog"
      aria-modal="true"
      aria-label="Búsqueda"
      (click)="onSheetBackdrop()"
    >
      <div class="search-overlay__sheet" #sheet (click)="onSheetContentClick($event)">
        <header class="search-overlay__sheet-header">
          <app-search-bar
            class="search-overlay__sheet-search"
            placeholder="Buscar cartas, juegos..."
            [autofocus]="true"
            [initialValue]="service.query()"
            (queryChange)="onSheetQuery($event)"
            (search)="onSheetSearch($event)"
            (submit)="onSheetSubmit($event)"
          />
          <button
            type="button"
            class="search-overlay__sheet-close"
            aria-label="Cerrar búsqueda"
            (click)="onClose()"
          >
            <app-icon [icon]="closeIcon" [size]="20" color="currentColor" />
          </button>
        </header>
        <div class="search-overlay__body">
          <ng-container *ngTemplateOutlet="body" />
        </div>
      </div>
    </div>
  } @else {
    <div class="search-overlay search-overlay--dropdown" role="presentation">
      <ng-container *ngTemplateOutlet="body" />
    </div>
  }
}

<ng-template #body>
  <span class="search-overlay__sr" role="status" aria-live="polite">
    {{ liveMessage() }}
  </span>

  @switch (service.status()) {

    @case ('loading') {
      <ul
        class="search-overlay__list"
        role="listbox"
        id="search-listbox"
        aria-label="Cargando resultados"
      >
        @for (i of skeletonRows; track i) {
          <li><app-search-skeleton-row /></li>
        }
      </ul>
    }

    @case ('success') {
      <ul
        class="search-overlay__list"
        role="listbox"
        id="search-listbox"
        aria-label="Resultados de búsqueda"
      >
        @for (product of service.results(); track product.id; let i = $index) {
          <li>
            <app-search-result-row
              [product]="product"
              [query]="service.query()"
              [rowId]="rowId(i)"
              [highlighted]="service.highlightedIndex() === i"
              (select)="onSelectRow($event)"
              (quickAdd)="onQuickAdd($event)"
              (notifyRequest)="onNotifyRequest($event)"
              (notifyCancel)="onNotifyCancel($event)"
            />
          </li>
        }
      </ul>
      <button
        type="button"
        class="search-overlay__footer"
        (mousedown)="onCommit()"
      >
        <span>
          Ver los {{ service.totalCount() }}
          {{ service.totalCount() === 1 ? 'resultado' : 'resultados' }}
          para &ldquo;{{ service.query() }}&rdquo;
        </span>
        <app-icon [icon]="arrowIcon" [size]="16" color="currentColor" />
      </button>
    }

    @case ('empty') {
      <div class="search-overlay__state">
        <img
          class="search-overlay__mascot"
          [src]="mascotUrl"
          alt=""
          width="120"
          height="120"
          loading="lazy"
          aria-hidden="true"
        />
        <p class="search-overlay__state-title">
          No encontramos nada para &ldquo;{{ service.query() }}&rdquo;
        </p>
        <p class="search-overlay__state-text">
          Probá con otro término o revisá la ortografía.
        </p>
      </div>
    }

    @case ('error') {
      <div class="search-overlay__state">
        <img
          class="search-overlay__mascot"
          [src]="mascotUrl"
          alt=""
          width="120"
          height="120"
          loading="lazy"
          aria-hidden="true"
        />
        <p class="search-overlay__state-title">Algo salió mal al buscar</p>
        <p class="search-overlay__state-text">
          Revisá tu conexión y volvé a intentarlo.
        </p>
        <app-button variant="primary" (click)="onRetry()">Reintentar</app-button>
      </div>
    }

    @default {
      @if (showRecents()) {
        <div class="search-overlay__recents">
          <div class="search-overlay__recents-header">
            <span class="search-overlay__recents-label">Búsquedas recientes</span>
            <button
              type="button"
              class="search-overlay__recents-clear"
              (mousedown)="onRecentClear($event)"
            >
              Limpiar
            </button>
          </div>
          <ul class="search-overlay__chips" role="list">
            @for (term of service.recent(); track term) {
              <li class="search-overlay__chip-wrap">
                <button
                  type="button"
                  class="search-overlay__chip"
                  (mousedown)="onRecentClick(term, $event)"
                >
                  {{ term }}
                </button>
                <button
                  type="button"
                  class="search-overlay__chip-remove"
                  [attr.aria-label]="'Quitar ' + term + ' de búsquedas recientes'"
                  (mousedown)="onRecentRemove(term, $event)"
                >
                  <app-icon [icon]="closeIcon" [size]="12" color="currentColor" />
                </button>
              </li>
            }
          </ul>
        </div>
      } @else if (showEmptyHint()) {
        <div class="search-overlay__state search-overlay__state--hint">
          <img
            class="search-overlay__mascot"
            [src]="mascotUrl"
            alt=""
            width="100"
            height="100"
            loading="lazy"
            aria-hidden="true"
          />
          <p class="search-overlay__state-title">¿Qué estás buscando?</p>
          <p class="search-overlay__state-text">
            Escribe el nombre de una carta, juego o expansión.
          </p>
        </div>
      }
    }
  }
</ng-template>
